import Vue from 'vue'
import {getData} from '@/app/plugins/utils'
import {get} from "lodash";

// update password
export const searchSlug = (payload) => {
  return Vue.http.get(process.env.VUE_APP_BASE_API+'marketplace/slug/'+payload, {}).then(getData)
}

export const postLogin = (payload) => {
  return Vue.http.post(process.env.VUE_APP_BASE_API+'login', payload).then(getData)
}

export const postLogin2FA = (payload) => {
  return Vue.http.post(process.env.VUE_APP_BASE_API+'two_factor', payload).then(getData)
}
export const postGenerateCodeGoogle2FA = (userId, payload) => {
  return Vue.http.post(process.env.VUE_APP_BASE_API+`user/${userId}/generate_qrcode_google`, payload).then(obj => obj)
}
export const AcceptInvite = (payload) => {
  // return Vue.http.post(api.user.accept_invite.replace('{invite}', payload.token), payload).then(getData)
}

// update password
export const forgotPassword = (payload) => {
  // /auth/password/forgot
  return Vue.http.post(process.env.VUE_APP_BASE_API+'reset_password', payload).then(getData)
}

// update password
export const changePassword = (payload) => {
  return Vue.http.post(process.env.VUE_APP_BASE_API+'auth/password/reset', payload).then(getData)
}
// get current user's data
export const updatePassword = (payload) => Vue.http.put(process.env.VUE_APP_BASE_API+'auth/password/update', payload).then(getData)

// get current user's data
export const loadUserData = () => Vue.http.get(process.env.VUE_APP_BASE_API+'me').then(getData)


// revoke current token
export const revokeToken = () =>
  Vue.http.post(process.env.VUE_APP_BASE_API+'refresh_token').then(getData)

// logout
export const logout = () =>
  Vue.http.get(process.env.VUE_APP_BASE_API+'logout').then(getData)
